<template>
    <div>
        <h1>
            <el-page-header @back="goBack" :content="category.name.concat('关联')">
            </el-page-header>
        </h1>
        <el-card class="form-container" shadow="never">
            <el-button type="primary" @click="showDetails('添加图标')">添加图标</el-button>
        </el-card>
        <el-card class="form-container" shadow="never">
            <el-table border
                      :data="selectList"
                      height="690"
                      style="width: 100%">
                <el-table-column label="应用ID" prop="icon.id" align="center"></el-table-column>
                <el-table-column  label="应用图片"  align="center">
                    <template slot-scope="scope">
                        <template>
                            <img :src="VUE_APP_CDN_URL+scope.row.icon.image" width="60px" height="60px" />
                        </template>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="1234px" :before-close="cancel">
            <el-table border
                      ref="multipleTable"
                      :data="icons"
                      tooltip-effect="dark"
                      style="width: 100%"
                      @selection-change="handleSelectionChange"
                      stripe
                      :row-key="getRowKeys"
                      :row-class-name="gameRowTableClass">
                <el-table-column
                        type="selection"
                        :reserve-selection="true"
                        width="55">
                </el-table-column>
                <el-table-column label="图标ID" prop="id" align="center"></el-table-column>
                <el-table-column  label="icon图片"  align="center">
                    <template slot-scope="scope">
                        <template>
                            <img :src="VUE_APP_CDN_URL+scope.row.image" width="60px" height="60px" />
                        </template>
                    </template>
                </el-table-column>
            </el-table>

            <h1 style="text-align: center;">
                <el-button type="primary" @click="confirm">确 定</el-button>
                <el-button type="info" @click="cancel">取 消</el-button>
            </h1>

        </el-dialog>

    </div>
</template>

<script>
    import {
        findIconCategoryRel,
        saveIconCategoryRel,
        icons,
    }from "@/http/iosApi";
    export default {
        name: "SelectIcon",
        data(){
            return{
                category: {},
                icons:[],
                selectForm:{},
                selectList:[],
                VUE_APP_CDN_URL: process.env.VUE_APP_CDN_URL,
                dialogTitle:'',
                multipleSelection: [],
                dialogVisible : false,
                iconSelectors :{},
            }
        },
        methods:{
            goBack() {
                this.$router.push({path: '/iconCategory'});
            },
            getRowKeys(row){
                return row.id
            },
            gameRowTableClass({row,rowIndex}){
                row.index=rowIndex
            },
            queryList(){
                findIconCategoryRel(this.category.id).then(resp => {
                    this.selectList = resp.data.info;
                })
            },
            iconList(){
                icons().then(resp => {
                    this.icons = resp.data.info;
                    this.selectList.forEach(item => {
                        this.$refs.multipleTable && this.$refs.multipleTable.toggleRowSelection(item.icon, true)
                    })
                })
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            showDetails(title) {
                this.dialogTitle = title;
                this.dialogVisible = true;
                this.iconList();

            },
            clear(){
                this.$refs.multipleTable.clearSelection();
            },

            confirm(){
                let iconIds =[];
                this.iconSelectors.categoryId = this.category.id;
                this.multipleSelection.forEach(item =>{
                    iconIds.push(item.id)
                });
                this.iconSelectors.iconIds = iconIds;
                let _message = '';
                if(this.iconSelectors.iconIds === '' || this.iconSelectors.iconIds.length<1){
                    _message = '请勾选图标'
                }
                if(_message){
                    this.$message({
                        message: _message,
                        type: 'error'
                    });
                    return;
                }
                saveIconCategoryRel(this.iconSelectors).then(resp=> {
                    if (resp.data.status===0){
                        this.dialogVisible=false;
                        this.queryList();
                    }
                });
            },
            cancel(){
                this.clear();
                this.dialogVisible=false;
            }

        },
        created() {
            this.category = this.$store.state.category;
            this.queryList();
        }
    }
</script>

<style scoped>

</style>